import React, { useState, useEffect } from 'react';
import { Form } from 'react-bootstrap';
import FavoriteDropdown from './FavoriteDropdown';

const SpecialProductRow = ({ specialProduct, onUpdate, onDelete, furnitureTypes = [] }) => {
  const [editData, setEditData] = useState({
    description: specialProduct.description,
    price: specialProduct.price,
    quantity: specialProduct.quantity || 1,
    productTypeId: specialProduct.productTypeId || ''
  });

  useEffect(() => {
    setEditData({
      description: specialProduct.description,
      price: specialProduct.price,
      quantity: specialProduct.quantity || 1,
      productTypeId: specialProduct.productTypeId || ''
    });
  }, [specialProduct]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    const updatedValue = name === 'price' || name === 'quantity' ? Number(value) : value;
    
    const newData = {
      ...editData,
      [name]: updatedValue
    };
    setEditData(newData);
    
    onUpdate(specialProduct.id, {
      ...newData,
      productTypeId: newData.productTypeId ? Number(newData.productTypeId) : null
    });
  };

  return (
    <tr style={{ backgroundColor: '#f8f9fa', borderLeft: '4px solid #17a2b8' }}>
      <td>
        <button
          className="btn btn-danger btn-sm"
          onClick={() => onDelete(specialProduct.id)}
        >
          Eliminar
        </button>
      </td>
      <td>
        <FavoriteDropdown
          value={editData.productTypeId}
          onChange={(e) => handleChange({ target: { name: 'productTypeId', value: e.target.value } })}
          options={furnitureTypes}
          placeholder="Tipo *"
          nameField="typeName"
          className="styled-select form-control-sm"
        />
      </td>
      <td colSpan="3">
        <div className="d-flex align-items-center">
          <span className="badge bg-info me-2">Especial</span>
          <Form.Control
            as="textarea"
            rows={1}
            name="description"
            value={editData.description}
            onChange={handleChange}
            className="form-control-sm"
            placeholder="Descripción del producto especial"
            data-testid={`description-input-${specialProduct.id}`}
          />
        </div>
      </td>
      <td>
        <Form.Control
          type="number"
          name="quantity"
          value={editData.quantity}
          onChange={handleChange}
          className="form-control-sm"
          min="1"
          data-testid={`quantity-input-${specialProduct.id}`}
        />
      </td>
      <td>
        <Form.Control
          type="number"
          name="price"
          value={editData.price}
          onChange={handleChange}
          className="form-control-sm"
          step="0.01"
          data-testid={`price-input-${specialProduct.id}`}
        />
      </td>
    </tr>
  );
};

export default SpecialProductRow;